import { VirtualItem, Virtualizer } from 'lib/react-virtual'
import { theme } from 'lib/theme'
import { useCallback } from 'react'

interface VirtualRowsProps {
  v: Virtualizer
  children: (props: {
    virtualRow: VirtualItem
    measureElementRow: (el: HTMLElement) => void
  }) => React.ReactNode
  // Note: Should be passed in memoized
  stickyIndexes?: number[]
}

export const VirtualRows = ({ children, v, stickyIndexes = [] }: VirtualRowsProps) => {
  const isSticky = (index: number) => stickyIndexes.includes(index)

  // Re-measure the row the element is within.
  const measureElementRow = useCallback(
    (el: HTMLElement) => setTimeout(() => v.measureElement(el.closest('[data-index]'))),
    [v]
  )

  return (
    <div
      style={{
        height: `${v.getTotalSize()}px`,
        width: '100%',
        position: 'relative'
      }}
    >
      {v.getVirtualItems().map((virtualRow) => {
        console.log('virtualRow', virtualRow)
        return (
          <div
            key={`vr-${virtualRow.key}`}
            data-key={virtualRow.key}
            data-index={virtualRow.index}
            style={{
              top: 0,
              left: 0,
              width: '100%',
              ...(isSticky(virtualRow.index)
                ? {
                    position: 'sticky',
                    zIndex: theme.zIndices.foreground.toString()
                  }
                : {
                    position: 'absolute',
                    transform: `translateY(${virtualRow.start}px)`
                  })
            }}
          >
            {children({ virtualRow, measureElementRow })}
          </div>
        )
      })}
    </div>
  )
}
